import { Center, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useParams } from "react-router";
import { publicCvQuery } from "../api/queries";
import { FitCv } from "../cv/fit";
import { useMessages } from "../i18n/provider";
import styles from "./embed.module.css";

export function EmbedPage() {
  const t = useMessages();
  const { slug = "" } = useParams();
  const { data, isLoading, isError } = useQuery(publicCvQuery(slug));

  useEffect(() => {
    if (!data) return;
    const name = data.document.profile.fullName || data.document.title;
    document.title = name;
    return () => {
      document.title = "YourCV";
    };
  }, [data]);

  useEffect(() => {
    const root = document.documentElement;
    root.dataset.yourcvEmbed = "true";
    return () => {
      delete root.dataset.yourcvEmbed;
    };
  }, []);

  useEffect(() => {
    if (!data || typeof ResizeObserver === "undefined") return;
    const node = document.getElementById("cv-print");
    if (!node) return;
    const post = () => {
      const height = Math.ceil(
        Math.max(node.getBoundingClientRect().height + 32, document.body.scrollHeight),
      );
      window.parent?.postMessage({ type: "yourcv:height", height }, "*");
    };
    const observer = new ResizeObserver(post);
    observer.observe(node);
    post();
    window.addEventListener("load", post);
    return () => {
      observer.disconnect();
      window.removeEventListener("load", post);
    };
  }, [data]);

  if (isLoading) {
    return (
      <Center h="100dvh">
        <Text size="sm" c="dimmed">
          {t("common.loading")}
        </Text>
      </Center>
    );
  }

  if (isError || !data) {
    return (
      <Center h="100dvh" px="md">
        <Text size="sm" c="dimmed">
          {t("public.notFound")}
        </Text>
      </Center>
    );
  }

  return (
    <main className={styles.root}>
      <FitCv doc={data.document} branded={data.branded} />
    </main>
  );
}
